module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "examine_vue"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.resultData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "cell-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adTitle",
      "label": _vm.$t('advert.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('advert.classify'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.adTypeList), function(item) {
          return (item.adtypeId === scope.row.adType) ? _c('span', [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": _vm.$t('advert.position'),
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.adPosition == 0) ? _c('span', [_vm._v("首页banner")]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 1) ? _c('span', [_vm._v("启动界面")]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_appadv')))]) : _vm._e(), _vm._v(" "), (scope.row.adPosition == 2) ? _c('span', [_vm._v("个人中心banner")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adStartEnd",
      "label": _vm.$t('advert.ableDate'),
      "formatter": _vm.dateFormat,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adCreateUsername",
      "label": _vm.$t('advert.addUser'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adCreateTime",
      "label": _vm.$t('advert.addDate'),
      "width": "180"
    }
  }, [_vm._v("\n      :formatter=\"dateFormat\"\n    ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('paging', {
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('menu.advertManageSub.examine'),
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.adTitle))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify')
    }
  }, _vm._l((_vm.adTypeList), function(item) {
    return (item.adtypeId === _vm.editorForm.adType) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(item.adtypeName))]) : _vm._e()
  })), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position')
    }
  }, [
    [(_vm.editorForm.adPosition == 0) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.banner')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adPosition == 1) ? _c('span', {
      staticClass: "grey_color"
    }, [_vm._v(_vm._s(_vm.$t('advert.positionSub.starPage')))]) : _vm._e()]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [(_vm.editorForm.adUrltype == '0') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adUrltype == '1') ? _c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))]) : _vm._e()]), _vm._v(" "), (_vm.editorForm.adUrltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.application.appName))])]) : _vm._e(), _vm._v(" "), (_vm.editorForm.adUrltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.editorForm.adUrl))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('span', {
    staticClass: "grey_color"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.editorForm.adStartEnd)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl + _vm.editorForm.adImgurl,
      "width": "100%",
      "height": "auto"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.isPass'),
      "prop": "resource"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.isAble),
      callback: function($$v) {
        _vm.isAble = $$v
      },
      expression: "isAble"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.pass')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.notPass')))])], 1)], 1), _vm._v(" "), (_vm.isAble === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.refusal')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.refuse_reason),
      callback: function($$v) {
        _vm.refuse_reason = $$v
      },
      expression: "refuse_reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sbIsAble
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.ok')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dcfb7b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advert/examine.vue
// module id = 965
// module chunks = 0